<template>
    <div class="staffing home_bg">
        <Header></Header>
        <div style="width: 100%;height: 80px;"></div>
        <div class="wx_box">
            <div class="wx_main">
                <div class="top">
                    <div class="wx_title">
                        <span>园区人员管理</span>
                    </div>
                </div>
                <div class="search_top">
                    <div class="search_box">
                        <span class="label">筛选</span>
                        <el-select v-model="tabPage.code" placeholder="职位" size="medium" clearable>
                            <el-option
                                    v-for="item in position_list"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input placeholder="输入姓名或手机号" v-model="tabPage.keyword" size="medium"></el-input>
                      <el-input placeholder="请输入内容" v-model="tabPage.keyword" class="input-with-select" size="medium" style="display: none;">
                          <div class="searchIcon" slot="prepend"><img src="../../assets/images/search.png" alt=""></div>
                      </el-input>
						<span class="label"></span>
						<el-button type="primary" @click="search()">搜索</el-button>
                    </div>
                    <div class="btns">
                        <el-button class="addBtn" @click="editPersonnelShow = true">添加人员</el-button>
						 <el-button class="addBtn" @click="return_farm()">返回当前园区</el-button>
                    </div>
                </div>
                <el-table :data="tableData" class="wx_table" :row-class-name="tableRowClassName">
                  <el-table-column prop="name" label="职位"></el-table-column>
                  <el-table-column prop="nickname" label="姓名"></el-table-column>
                  <el-table-column prop="mobile" label="账号/手机号"></el-table-column>
                  <el-table-column prop="month_salary" label="薪资"></el-table-column>
				  <el-table-column prop="employ_date" label="入职时间"></el-table-column>
                  <el-table-column prop="Photo" label="照片" >
                      <template slot-scope="scope">
                          <img :src="scope.row.avatar" alt="">
                      </template>
                  </el-table-column>
                    <el-table-column label="操作" width="460" >
                        <template slot-scope="scope" >
							<em v-if="scope.row.position_code==150">
                      
                            <el-button class="del_btn" type="warning" plain size="small" >不能操作</el-button>
							
							</em>
							<em v-else>
							<el-button class="edit_btn" type="primary" plain size="small" @click="editPerson(scope.row)">编辑</el-button>
							<el-button class="del_btn" type="danger" plain size="small" @click="deleteData(scope.row.id,1)">删除</el-button>
							<el-button class="detail_btn" type="success" plain size="small" v-if="scope.row.is_principal==2" @click="setPrincipal(scope.row.id,1)">设为负责人</el-button>
							<el-button class="del_btn" type="warning" plain size="small" v-if="scope.row.is_principal==1"    @click="setPrincipal(scope.row.id,2)">取消负责人</el-button>
							</em>
                        </template>
				
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination v-show="tabPage.total>0"  @size-change="handleSizeChange" @current-change="handleCurrentChange"     :current-page="tabPage.currentPage" :page-size="tabPage.pagesize"  :total="tabPage.total"></el-pagination>
  
				</div>
                <div class="tip_box">
                    <h5>说明：</h5>
                    <p>1、经理账号拥有园区所有栏目的浏览、查看权限，不参与任何具体事务。</p>
                    <p>2、项目主管账号拥有园区填写任务的权限，以及分派任务、发布日志等权限。</p>
                    <p>3、助理账号拥有园区填写任务的权限，以及查看任务和日志的权限，及少量板块的浏览权限。</p>
                    <p>4、当申请提交之后，平台方将为园区提供技术员账号，安排园区任务，指导园区的日常工作。</p>
                    <p>5、同一账号在一个园区内只能拥有一种职位。</p>
                    <p>6、请至少添加一个项目主管。</p>
                </div>
            </div>
        </div>
        <!--编辑/添加人员弹窗-->
      <WxMessageBox :show="editPersonnelShow" @save="editPersonnelSave" @canse="editPersonnelCanse">
      	
          <div slot="content">
      		 <el-form :model="userForm" :rules="userRules" ref="userForm" label-width="0px">
              <div class="wx_form">
      			
                  <div class="wx_top">
      				 <el-form-item label="" prop="avatar">
                      <el-upload
                              class="avatar-uploader"
                               :action="uploadAction"
      						 :headers="myHeaders"
      						 :file-list="avatarfileList"
                              :show-file-list="false"
      						
                              :on-success="handlePersonnelSuccess"
                              :before-upload="beforePersonnelUpload">
                        
      					 <img :src="userForm.avatar" v-if="avatarfileList.length>0" style="width: 70px; height: 70px;">
                          <div class="unloadIcon" v-else></div>
                      </el-upload>
      				</el-form-item>
      				
                  </div>
      			
      	
                  <div class="form_item">
                      <span class="label">账号\手机号</span>
                      <div class="input">
      					 <el-form-item label="" prop="mobile">
                          <el-input v-model="userForm.mobile" size="mini" :readonly="readonly"></el-input>
      					</el-form-item>
                      </div>
                  </div>
                  <div class="form_item">
                      <span class="label">工种</span>
                      <div class="input">
      					 <el-form-item label="" prop="position_code">
                          <el-select v-model="userForm.position_code" placeholder="请选择" size="mini">
                              <el-option
                                      v-for="item in position_list"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.code" v-if="item.code!=150">
                              </el-option>
                          </el-select>
      					</el-form-item>
                      </div>
                  </div>
                  <div class="form_item">
                      <span class="label">姓名</span>
                      <div class="input">
      					 <el-form-item label="" prop="nickname">
                          <el-input v-model="userForm.nickname" size="mini"></el-input>
      					</el-form-item>
                      </div>
                  </div>
      
                  <div class="form_item">
                      <span class="label">薪资</span>
                      <div class="input">
      					 <el-form-item label="" prop="salary">
                          <el-input class="w106" v-model="userForm.salary" size="mini" placeholder="请填数字" type="number"></el-input>
      					</el-form-item>
                      </div>
                      <span class="tip">元/月</span>
                  </div>
				  
				  <div class="form_item">
				      <span class="label">入职时间</span>
				      <div class="input">
				        <el-form-item label="" prop="employ_date">
				          <el-date-picker
				                  v-model="userForm.employ_date"
				                  type="date"
				                  size="mini"
								  value-format="yyyy-MM-dd"
				                  placeholder="选择年">
				          </el-date-picker>
						  </el-form-item>
				      </div>
				  
				  </div>
              </div>
      		</el-form>
          </div>
      	
      </WxMessageBox>
        <!--点击删除弹窗-->
        <WxMessageBox :show="delShow" @save="delSave" @canse="delCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定删除此项，删除后，</p>
                    <p>将不可恢复！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--点击确认弹窗-->
        <WxMessageBox :show="saveShow" @save="saveSave" @canse="saveCanse">
            <div slot="content">
                <div class="word">
                    <p>你是否确定本次操作！</p>
                </div>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
	import {getFarmUser,createFarmUser,deleteFarmOther,setPrincipal} from '@/api/api'
	 import axios from 'axios';
    import Header from '@/components/Header';
    import OpenSteps from '@/components/OpenSteps';
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "staffing",
        data(){
            return{
				uploadAction:axios.defaults.baseURL+"/upload/image",
				myHeaders: {
				         authorization: "Bear "+localStorage.getItem("token")
				       },

                tabPage:{
					code:'',
					mobile:'',
					keyword:'',
					currentPage:1,
					total:0,
                    pagesize:10,    // 每页的数据
                },
                editPersonnelShow:false,
                delShow:false,
                saveShow:false,
				readonly:false,
				tableData: [],
				position_list:[],
				avatarfileList:[],
				userForm:{ 
					       id:'',
					       mobile:'',
						   nickname:'',
						   avatar:'',
						   position_code:'',
						   employ_date:'',
						   salary:'',	   
				},
				userRules: {					
					mobile: [{required: true,message: '请输入手机号码',trigger: 'blur'},
					         { pattern:/^((0\d{2,3}-\d{7,8})|(1[3567894]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" }
					        ],
				    nickname: [{required: true,message: '请输入姓名',trigger: 'blur'}
							  ],
					 avatar: [{required: true,message: '请上传头像',trigger: 'blur'}
					 		],
					/* password: [{required: true,message: '请输入密码',trigger: 'change'},
					           {min: 8,max: 16,message: '必须是8-16位',trigger: 'blur'}
							  ], */
					position_code: [{required: true,message: '请选择职位',trigger: 'change'}
							       ],
					salary: [{required: true,message: '请输入工资',trigger: 'change'}
							],	
					employ_date: [{required: true,message: '请选择入职时间',trigger: 'change'}
							],							
				},
            }
        },
		mounted() {
			this.farm_id=this.$route.params.id,
			this.get_farm_user(this.$route.params.id)
		},
        methods:{
			get_farm_user(farm_id) {
				getFarmUser(farm_id,this.tabPage).then(resp => {
					 this.tableData=resp.user.data
					
					 this.tabPage.total = resp.user.total;
					 this.position_list=resp.position
				})
			},
            // 表格斑马纹
            tableRowClassName({row, rowIndex}) {
                if (rowIndex % 2 !== 1) {
                    return 'single-row';
                }else{
                    return 'double-row';
                }
            },
            // 分页
            handleSizeChange: function (size) {
                this.tabPage.pagesize = size;
				console.log(size)
            },
            handleCurrentChange: function(currentPage){
                this.tabPage.currentPage = currentPage;
				 this.get_farm_user(this.farm_id,this.tabPage)
				console.log(currentPage)
            },
			
			editPerson(row){
				
				this.readonly=true
				this.userForm["id"]=row.id
				this.userForm["avatar"]=row.avatar
				this.userForm["mobile"]=row.mobile,
				this.userForm["nickname"]=row.nickname,
				this.userForm["salary"]=row.month_salary
				this.userForm["position_code"]=row.position_code
				this.userForm["employ_date"]=row.employ_date
				 //this.avatarfileList.push(row.user.avatar)
				 this.avatarfileList.push({path:row.avatar})
				 this.editPersonnelShow=true
			},
			return_farm(){
				this.$router.push("/park/detail/"+this.farm_id)
			},
			setPrincipal(id,type){
				setPrincipal(id,type).then(resp=>{
					this.get_farm_user(this.farm_id,this.tabPage)
					this.$message.success(resp.msg)
				})
			},
			search(){
				  this.get_farm_user(this.farm_id,this.tabPage)
			},
            // 编辑/添加人员弹窗确认
            editPersonnelSave(){
               this.$refs["userForm"].validate((valid) => {
               	if (valid) {
               
               		 createFarmUser(this.farm_id,this.userForm).then(resp=>{
               			if(resp.status==1){								
                             this.$message.success(resp.msg);
               			  this.get_farm_user(this.farm_id,this.tabPage)
               			  this.editPersonnelShow = false	
               								this.$refs["userForm"].resetFields()							
               									
               			}else{
               				this.$message.error(resp.msg);
               			}
               			}).catch(error=>console.log(error))
               	} else {
               		console.log('error submit!!');
               		return false;
               	}
               });
            },
			deleteData(id,type){
				//删除农场相关人员
				if(type==1){
					this.delete_controller="farm_user"
					this.delete_action="delete_farm_user"
				}
				if(type==2){
					this.delete_controller="farm_crop"
					this.delete_action="delete_farm_crop"
				}
				if(type==3){
					this.delete_controller="farm_area"
					this.delete_action="delete_farm_area"
				}
				
				if(type==4){
					this.delete_controller="farm_insect_pest"
					this.delete_action="delete_farm_insect_pest"
				}
				this.delete_id=id;
				this.delShow=true
			},
            // 编辑/添加人员弹窗取消
            editPersonnelCanse(){
                this.editPersonnelShow = false
            },
            // 点击删除弹窗确定
            delSave(){
                this.delShow = false
                this.$nextTick(()=>{
                    this.saveShow = true
                })
            },
            // 点击删除弹窗取消
            delCanse(){
                this.delShow = false
            },
            // 点击确认弹窗
          // 点击确认弹窗
          saveSave(){
          deleteFarmOther(this.delete_id,this.delete_controller,this.delete_action).then(resp=>{
          	
          		 console.log("dadada")
				 if(resp.status==0){
					 this.$message.error(resp.msg)
				 }else{
          		 this.$message.success(resp.msg)
				 }
          		 this.saveShow = false
          	
          	 this.get_farm_user(this.farm_id,this.tabPage)
          	
          })
              
          },
            // 点击确认弹窗
            saveCanse(){
                this.saveShow = false
            },
			// 编辑、添加人员上传
			beforePersonnelUpload(file) {
			   const isJPG = file.type === 'image/jpeg';
			    const isPng = file.type === 'image/png';
				 const isLt2M = file.size / 1024 / 1024 < 2;
				 if (!isLt2M) {
				     this.$message.error('上传头像图片大小不能超过 2MB!');
				 }
			    if (!isJPG && !isPng) {
					
			        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
			       return false
			   }else{
			     	return true
			   }
			  
			},
			handlePersonnelSuccess(res, file) {
				this.userForm["avatar"]=res.data;
				 this.avatarfileList.push({url:res.data})
			},
        },
        components: {
            Header,
            OpenSteps,
            WxMessageBox
        }
    }
</script>

<style lang="less">
    .staffing{
        .wx_box{
            .wx_main {
                background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                background-size: cover;
                padding: 11px 35px 50px 24px;
                .top {
                    overflow: hidden;
                }
                .search_top{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 30px;
                    .label{
                        font-size: 14px;
                        font-weight: 400;
                        color: #D0D0D0;
                        padding-right: 10px;
                    }
                    .el-input{
                        width: 160px;
                    }
                    .el-select{
                        width: 160px;
                        margin-right: 14px;
                    }
                    .input-with-select{
                        width: 250px;
                        margin-left: 14px;
                        .el-input-group__append, .el-input-group__prepend{
                            background: rgba(45, 153, 255, 0.3);
                        }
                    }
                    .btns{
                        .addBtn{
                            border: 1px solid #2D99FF;
                            background-color: transparent;
                            font-size: 18px;
                            font-weight: 400;
                            color: #2D99FF;
                            padding: 7px 18px;
                            border-radius: 0;
                        }
                    }
                }
                .wx_table{
                    margin-top: 25px;
                    .cell{
                        img{
                            width: 66px;
                            height: 36px;
                        }
                    }
                    .msg{
                        display: flex;
                        justify-content: center;
                        div{
                            &+div{
                                margin-left: 20px;
                            }
                            p{
                                font-size: 12px;
                                font-weight: 500;
                                color: #C7D7DE;
                                line-height: 17px;
                            }
                        }
                    }
                }
                .tip_box{
                    padding-top: 17px;
                    h5{
                        font-size: 18px;
                        font-weight: 500;
                        color: #C7D7DE;
                        line-height: 30px;
                    }
                    p{
                        font-size: 18px;
                        font-weight: 500;
                        color: #C7D7DE;
                        line-height: 30px;
                    }
                }
            }
        }
    }
</style>
